import { render, staticRenderFns } from "./CreatePaymentMethodForm.vue?vue&type=template&id=3c73ff62&scoped=true"
import script from "./CreatePaymentMethodForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreatePaymentMethodForm.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CreatePaymentMethodForm.vue?vue&type=style&index=0&id=3c73ff62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c73ff62",
  null
  
)

export default component.exports